module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-news u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative "
  }, [(_vm.newsOriginal.length > 5) ? _c('section', [(_vm.$root.width > 940) ? _c('app-news-slideshow', {
    staticClass: "u-hide@md",
    attrs: {
      "news": _vm.newsSlideshow,
      "share": _vm.contentPage.share,
      "footer": _vm.contentPage.taxonomies.more
    }
  }) : _c('app-news-slideshow-mobile', {
    staticClass: "u-hide u-block@md",
    attrs: {
      "news": _vm.newsSlideshow,
      "share": _vm.contentPage.share,
      "footer": _vm.contentPage.taxonomies.more
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-t-xxxl u-marg-t-lg@sm u-fit-w",
    class: [_vm.newsOriginal.length <= 5 ? 'c-big-title' : '']
  }, [_c('div', {
    staticClass: "u-flex u-flex-jc--center"
  }, [_c('app-btn', {
    staticClass: "u-valign-middle",
    on: {
      "click": function($event) {
        _vm.openModalRegister()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.support)
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "u-marg-t-xxxl u-flex u-flex-fw--wrap"
  }, _vm._l((_vm.news), function(n, index) {
    return (n.videoGameID === _vm.filterVideoGame.id || _vm.filterVideoGame.id === 0) ? _c('app-fadein', {
      key: index,
      staticClass: "c-page-news__news-container u-w1of3 u-w1of2@lg u-fit-w@sm",
      attrs: {
        "delay": index * 70,
        "move": index === 1 && _vm.news.length === 3 ? 0 : -50
      }
    }, [_c('app-news', {
      staticClass: "u-marg-x-xs u-marg-b-xxl",
      attrs: {
        "type": n.type,
        "category": _vm.getArticleTypeById(n.type).name,
        "date": n.date,
        "link": _vm.getArticleUrlBySlug(n.slug),
        "cover": n.cover,
        "title": n.title,
        "text": n.resume,
        "footer": _vm.contentPage.taxonomies.more,
        "share": _vm.contentPage.share
      }
    })], 1) : _vm._e()
  })), _vm._v(" "), (_vm.isMoreBtnEnable) ? _c('div', {
    staticClass: "u-align-center"
  }, [_c('app-btn', {
    on: {
      "click": function($event) {
        _vm._moreNews()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.moreNews)
    }
  })])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5964cb4e"}!./src/scripts/components/page-news/template.html
// module id = 922
// module chunks = 0